module.exports = __webpack_public_path__ + "img/Comic_40.ea6644ba.png";